<template>
  <smd-one-col-layout>
    <div class="container">
      <div class="logo"></div>

      <h2>{{ header }}</h2>
      <p v-if="message">{{ message }}</p>

      <smd-btn class="d-block mlr-auto" @click="backToHome">GO BACK TO NOW SERVING</smd-btn>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import {HOME_ROUTE} from '@/router/routes';

  export default {
    name: 'ErrorPage',
    props: {
      header: {type: String, default: 'PAGE NOT FOUND'},
      message: {type: String, default: null},
    },
    methods: {
      backToHome() {
        this.$router.push({name: HOME_ROUTE});
      },
    },
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .logo {
    width: 300px;
    height: 300px;
    background-size: contain;
    background: url('~@/assets/images/now-serving-heart-large.svg') no-repeat center;

    @include responsive(tablet) {
      width: 150px;
      height: 150px;
    }
  }

  h2 {
    font-size: 64px;
    font-weight: font(bold);
    color: color(label, text);
    margin-bottom: space(m);
    line-height: unset;

    @include responsive(tablet) {
      font-size: font(xxl);
    }
  }

  p {
    font-size: font(l);
    margin-bottom: 16px;

    @include responsive(tablet) {
      font-size: font(base);
    }
  }
</style>
